export enum DistanceUnits {
  Miles = 'Miles',
  Kilometers = 'Kilometers'
}
